"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarContainer = exports.Avatar = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const styled_system_1 = require("styled-system");
const styled_1 = __importDefault(require("../../styles/styled"));
const __1 = require("..");
const Avatar = (_a) => {
    var { src, displayName = 'User', backgroundColor, color } = _a, otherProps = __rest(_a, ["src", "displayName", "backgroundColor", "color"]);
    const [missingImage, setMissingImage] = (0, react_1.useState)(!src);
    const imageUrl = src && src.length > 0;
    const noImage = !imageUrl || missingImage;
    return ((0, jsx_runtime_1.jsx)(exports.AvatarContainer, Object.assign({}, otherProps, { backgroundColor: noImage ? backgroundColor : 'transparent' }, { children: (0, jsx_runtime_1.jsxs)(__1.Box, Object.assign({ position: "relative" }, { children: [(0, jsx_runtime_1.jsx)(AvatarImage, Object.assign({}, otherProps, { onLoad: () => setMissingImage(false), onError: () => setMissingImage(true), src: src, alt: `${displayName}'s Avatar`, style: {
                        visibility: noImage ? 'hidden' : 'visible',
                    } })), (0, jsx_runtime_1.jsx)(AvatarMonogram, Object.assign({ color: color !== null && color !== void 0 ? color : '' }, otherProps, { style: { visibility: noImage ? 'visible' : 'hidden' } }, { children: displayName === null || displayName === void 0 ? void 0 : displayName.charAt(0) }))] })) })));
};
exports.Avatar = Avatar;
exports.Avatar.defaultProps = {
    size: 'small',
};
exports.Avatar.displayName = 'Avatar';
const AvatarImage = styled_1.default.img(props => {
    const size = props.theme.avatarSizes[props.size];
    return {
        transition: 'opacity 0.2s, width 400ms linear, height 400ms linear, border-radius 400ms linear',
        position: 'absolute',
        transform: 'translate(-50%,-50%)',
        width: size + 1,
        height: size + 1,
        borderRadius: Math.ceil(size * 0.5),
        objectFit: 'cover',
    };
});
exports.AvatarContainer = styled_1.default.div(props => {
    var _a;
    const size = props.theme.avatarSizes[props.size];
    return {
        width: size,
        height: size,
        borderRadius: Math.ceil(size * 0.5),
        backgroundColor: (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colors.azure,
        display: 'flex',
        justifyContent: 'center',
        transition: 'all 400ms linear',
        alignItems: 'center',
        overflow: 'hidden',
        flexShrink: 0,
    };
}, styled_system_1.space);
const AvatarMonogram = styled_1.default.div(({ color, size, theme }) => ({
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    color: color ? color : theme.colors.white,
    textTransform: 'uppercase',
    fontFamily: theme.text.headingFontFamily,
    fontSize: Math.floor(theme.avatarSizes[size] * 0.45),
    transition: 'all 400ms linear',
    userSelect: 'none',
}));
//# sourceMappingURL=avatar.js.map